import { mergeAttributes, Node } from "@tiptap/core"

export const CustomEmoji = Node.create({
  name: "customEmoji",
  group: "inline",
  inline: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      type: { default: null },
      style: { default: "width: 1em; height: 1em; object-fit: contain;" }
    }
  },

  parseHTML() {
    return [{ tag: "img[data-custom-emoji]" }]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "img",
      mergeAttributes(HTMLAttributes, {
        "data-custom-emoji": "",
        class: "custom-emoji"
      })
    ]
  },

  // @ts-ignore
  addCommands() {
    return {
      insertEmoji:
        options =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: options
          })
        }
    }
  }
})
